export const ActionsetUser = (user: any) => {
  return {
    type: "SET_USER",
    payload: user,
  };
};
